import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import { getLeaveTypes } from "../../../../services/RHService/LeaveTypeService";
import { updateLeaveType } from "../../../../services/RHService/LeaveTypeService";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";

const LeaveTypeList = ({ startLoading, stopLoading }) => {
  //variables
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [data] = useState([]);
  const [leavetypes, setLeavetypes] = useState([]);
  const [selectedLeavetype, setSelectedLeavetype] = useState(null);

  const handleShow = (leavetype) => {
    setSelectedLeavetype(leavetype);
    setShow(true);
  };
  //afficher les infos dans le tableau
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    startLoading();
    const data = await getLeaveTypes(getCurrentUserId());
    console.log("getLeaveTypes", data);
    setLeavetypes(data.success);
    stopLoading();
  };

  //pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };

  //colonnes de tableau
  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    { dataField: "nomConge", text: "Nom" },
    {
      dataField: "ispaid",
      text: "Type de congé",
      formatter: (cell, row) => {
        const badgeClass = row.ispaid ? "col-greenn" : "col-orange";
        const badgeText = row.ispaid ? "Payé" : "Non Payé";
        return (
          <div className="center">
            <div className={`badge_leave ${badgeClass}`}>{badgeText}</div>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        const badgeClass = row.status ? "col-greenn" : "col-orange";
        const badgeText = row.status ? "Active" : "Desactive";
        return (
          <div className="center">
            <div className={`badge_leave ${badgeClass}`}>{badgeText}</div>
          </div>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (cell, row) => {
        return (
          <div className="center">
            <Button
              style={{
                "background-color": "white",
                color: "black",
                "border-color": "transparent",
              }}
              onClick={() => {
                handleShow(row);
              }}
            >
              <i class="fa-solid fa-pencil"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const formData = {
        label: selectedLeavetype.nomConge,
        idLeaveType: selectedLeavetype.id,
        ispaid: selectedLeavetype.ispaid,
      };

      //   selectedLeavetype.label = selectedLeavetype.nomConge;
      //   console.log(selectedLeavetype);

      //   selectedLeavetype.idLeaveType = selectedLeavetype.id;
      console.log(formData);
      await updateLeaveType(formData);
      fetchData();
      handleClose();
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        exportCSV={{ onlyExportFiltered: true, exportAll: false }}
        search
      >
        {(props) => (
          <div>
            <Modal show={show} onHide={handleClose} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={12}>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Nom</label>
                          <input
                            type="text"
                            name="nomConge"
                            value={
                              selectedLeavetype
                                ? selectedLeavetype.nomConge
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedLeavetype({
                                ...selectedLeavetype,
                                nomConge: e.target.value,
                              })
                            }
                            className="form-control form-control-border"
                            placeholder="Nom"
                          />{" "}
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">
                            Type de congé
                          </label>
                          <select
                            className="custom-select form-control-border"
                            name="ispaid"
                            value={
                              selectedLeavetype !== null &&
                                selectedLeavetype.ispaid
                                ? "true"
                                : "false"
                            }
                            onChange={(e) =>
                              setSelectedLeavetype({
                                ...selectedLeavetype,
                                ispaid: e.target.value === "true",
                              })
                            }
                          >
                            <option value="true">Payé</option>
                            <option value="false">Non payé</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Status</label>
                          <select
                            className="custom-select form-control-border"
                            name="status"
                            value={
                              selectedLeavetype !== null &&
                                selectedLeavetype.status
                                ? "true"
                                : "false"
                            }
                            onChange={(e) =>
                              setSelectedLeavetype({
                                ...selectedLeavetype,
                                status: e.target.value === "true",
                              })
                            }
                          >
                            <option value="true">Active</option>
                            <option value="false">Désactive</option>
                          </select>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            <div className="content-header">
              <div className="container-fluid">
                <div className="row mb-2">
                  <div className="col-sm-6">
                    <h1 className="m-0">Liste des types de congé</h1>
                  </div>
                  {/* <div className="col-sm-6">
                                            <ol className="breadcrumb float-sm-right">
                                                <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li>
                                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                                <li className="breadcrumb-item active">Liste des types de congé</li>
                                            </ol>
                                        </div> */}
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div class="card card-dark">
                <div class="card-body">
                  <h5 class="card-title">Ajouter un type de congé</h5>

                  <Link to="/AddLeaveType">
                    <button
                      class="btn btn-dark  float-right"
                    // onClick={onAddDevisHandler}
                    >
                      {" "}
                      <i class="fas fa-plus"></i>
                    </button>
                  </Link>
                </div>
              </div>
              {/* <div className='row'>
                                    <div className='col-md-9 col-lg-9'></div>
                                    <div className='col-md-3 col-lg-3 right mb-2 '>
                                        <Link to="/settings/AddLeaveType" >
                                            <Button type="button" className="btn  btn-dark" style={{ "width": "auto", "margin": "auto" }}>Ajouter un type de congé
                                            </Button>
                                        </Link>
                                    </div>
                                </div> */}

              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header">
                      <h3 class="card-title">Liste des types de congé</h3>
                    </div>
                    <BootstrapTable
                      keyField="id"
                      data={leavetypes}
                      columns={columns}
                      pagination={paginationFactory(options)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </ToolkitProvider>
    </div>
  );
};
export default withLoader(LeaveTypeList);
